<template>
  <div class="container-fluid">
    <BarreFiltres :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />
    <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />
    <BarreInformations :informations="informations" @visibility-changed="barreInformationAffichee=$event" />  <!-- "information" doit être computed -->

    <ModalImportFichierCotation ref="modalImportFichierCotation" :datePropoId="dateIdSelectionnee" @rechargerPropo="chargerPropositionsApresImport()"/>
    <ModalImportFichesTechniques ref="modalImportFichesTechniques" :datePropoId="dateIdSelectionnee" :propoArticleId="propoArticleSelectionnee" :familleId="familleIdSelectionnee" :propoDesignation="propoDesignationSelectionnee" :propoReference="propoReferenceSelectionnee" :nomFichier="nomDuFichier" :contenuFichier="contenuDuFichier" @rechargerPropo="chargerPropositionsApresImport()"/>
    <ModalControleLienFicheTechnique ref="modalControleLienFicheTechnique" :datePropoId="dateIdSelectionnee" :familleId="familleIdSelectionnee" :nomFamille="nomFamilleSelectionnee" @rechargerPropo="chargerPropositionsApresImport()"/>
    <ModalImportFichesTechniquesGlobal ref="modalImportFichesTechniquesGlobal" :datePropoId="dateIdSelectionnee" :familleId="familleIdSelectionnee" :nomFichier="nomDuFichier" @rechargerPropo="chargerPropositionsApresImport()"/>
    <ModalAfficheDetailFT ref="modalAfficheDetailFT" :listeErreurs="listeErreurFicheTechnique" />

    <!--input pour l'import du fichier de cotation-->
    <input type="file" accept=".xls,.xlsx,.zip" @change="chargerFichierCotation($event)" style="display: none" ref="importCotations" />
    <!--input pour l'import des fiches TEchniques via un zip ou un pdf-->
    <input type="file" accept=".pdf" @change="chargerFichesTechniques($event)" style="display: none" ref="importFicheTechnique" />

    <div v-if="!afficherTableauPropositions" class="card table-scroll" :class="[{'height-responsive-100':!barreInformationAffichee, 'height-responsive-3b':barreInformationAffichee}]">
      <div class="card-body">
        Veuillez sélectionner une date et une famille s'il vous plaît.
      </div>
    </div>
    <div v-else class="card table-scroll" :class="[{'height-responsive-100':!barreInformationAffichee, 'height-responsive-3b':barreInformationAffichee}]">
      <div class="card-header table-header">
        <table class="table table-bordered table-sm text-center table-header">
          <colgroup>
            <col>
            <!-- <col width="75"> -->
            <col class="col-fixed-width-150-sm col-fixed-width-350-lg col-fixed-width-500-xl">
            <col width="75">
            <col class="col-fixed-width-100-sm col-fixed-width-150-lg col-fixed-width-200-xl">
            <col width="160">
            <col width="120">
            <col width="120">
            <col width="100">
            <col width="100">
            <col class="col-fixed-width-150-sm col-fixed-width-200-lg col-fixed-width-300-xl">
            <col width="65">
            <col width="40">
          </colgroup>
          <thead>
            <th>Unité de Besoin</th>
            <!-- <th>UC</th> -->
            <th>Désignation</th>
            <th>Réf.</th>
            <th>Marque</th>
            <th>Prix HT / UC</th>
            <th>Nb UC / UF</th>
            <th>Prix HT</th>
            <th>Unité Fact.</th>
            <th>UC EDI</th>
            <th>Commentaire</th>
            <th>FT</th>
            <th></th>
          </thead>
        </table>
      </div>
      <div v-if="!filtres.statuts.selection && !contientPropositionsModifiables(tableauPropositions)" class="card-body">
        Aucune proposition à traiter.
      </div>
      <div v-else class="table-body">
        <table id="tableauProduitAgap" class="table table-sm text-center" v-no-dragdrop>
          <colgroup>
            <col>
            <!-- <col width="75"> -->
            <col class="col-fixed-width-150-sm col-fixed-width-350-lg col-fixed-width-500-xl">
            <col width="75">
            <col class="col-fixed-width-100-sm col-fixed-width-150-lg col-fixed-width-200-xl">
            <col width="160">
            <col width="120">
            <col width="120">
            <col width="100">
            <col width="100">
            <col class="col-fixed-width-150-sm col-fixed-width-200-lg col-fixed-width-300-xl">
            <col width="65">
            <col width="35">
          </colgroup>
          <tbody>
            <template v-for="(categorie, iCategorie) in tableauPropositions.categories.filter(c => c.sousCategories.some(sc => sc.produits.some(p => filtrer(p))))">
              <tr class="table-header-tertiary" :key="'categorie-'+iCategorie">
                <td v-no-dragdrop v-if="pourcentageFluctuation(totalCategorie(categorie).totalPropo, totalCategorie(categorie).totalActif) != 0" colspan="12" class="aligner-gauche">
                  {{ categorie.categorie }} ({{ afficherPourcentageFluctuation(totalCategorie(categorie).totalPropo, totalCategorie(categorie).totalActif) }})<i :class="['ml-1',{'far fa-smile':pourcentageFluctuation(totalCategorie(categorie).totalPropo, totalCategorie(categorie).totalActif) < 0},{'far fa-frown':pourcentageFluctuation(totalCategorie(categorie).totalPropo, totalCategorie(categorie).totalActif) > 0}]"></i>
                </td>
                <td v-no-dragdrop v-else colspan="12" class="aligner-gauche">
                  {{ categorie.categorie }}
                </td>
              </tr>
              <template v-for="(sousCategorie, iSousCategorie) in categorie.sousCategories.filter(sc => sc.produits.some(p => filtrer(p)))">
                <tr class="table-header-secondary" :key="'ssCat-'+iCategorie+'categ'+iSousCategorie">
                  <td v-no-dragdrop colspan="12" class="aligner-gauche pl-3">
                    {{ sousCategorie.sousCategorie }}
                  </td>
                </tr>
                <template v-for="(produit, iProduit) in sousCategorie.produits.filter(p => filtrer(p))">
                  <!-- Ligne du prix Actif -->
                  <tr :key="'prodAgap-'+'ssCat'+iCategorie+'categ'+iSousCategorie+'prod'+iProduit" :class="[{'ligne-selectionnee':produit.produitAgapId === produitSelectionneId}]">
                    <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)" class="aligner-gauche">
                      <span class="note">[{{ produit.codeProduitAgap }}] </span>{{ produit.nomProduitAgap }}
                    </td>
                    <td v-no-dragdrop colspan="11" class="td-table">
                      <table id="tableauTarifFournisseur" class="table table-bordered table-sm text-center">
                        <colgroup>
                          <col class="col-fixed-width-150-sm col-fixed-width-350-lg col-fixed-width-500-xl">
                          <col width="75">
                          <col class="col-fixed-width-100-sm col-fixed-width-150-lg col-fixed-width-200-xl">
                          <col width="160">
                          <col width="120">
                          <col width="120">
                          <col width="100">
                          <col width="100">
                          <col class="col-fixed-width-150-sm col-fixed-width-200-lg col-fixed-width-300-xl">
                          <col width="65">
                          <col width="35">
                        </colgroup>
                        <tbody>
                          <!-- Ligne du Tarif Actif -->
                          <tr class="ligne-blanche" :key="'prix-'+'ssCat'+iCategorie+'categ'+iSousCategorie+'prod'+iProduit">
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)" class="aligner-gauche">
                              {{ propositionFournisseur(produit)?.prixActif?.designation }}
                            </td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)">
                              {{ propositionFournisseur(produit)?.prixActif?.reference }}
                            </td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)">
                              {{ propositionFournisseur(produit)?.prixActif?.marque }}
                            </td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)">
                              <span v-if="propositionFournisseur(produit)?.prixActif">{{ propositionFournisseur(produit)?.prixActif?.prixUnitaireHT | afficherPrix }} / {{ produit.uniteCotation }}</span>
                              <div v-if="propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT && propositionFournisseur(produit)?.prixActif?.prixUnitaireHT" :class="['bold600',{'text-success':pourcentageFluctuation(propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT, propositionFournisseur(produit)?.prixActif?.prixUnitaireHT) < 0},{'text-error':pourcentageFluctuation(propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT, propositionFournisseur(produit)?.prixActif?.prixUnitaireHT) > 0}]"><i :class="['ml-1',{'far fa-meh':pourcentageFluctuation(propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT, propositionFournisseur(produit)?.prixActif?.prixUnitaireHT)===0},{'far fa-smile':pourcentageFluctuation(propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT, propositionFournisseur(produit)?.prixActif?.prixUnitaireHT) < 0},{'far fa-frown':pourcentageFluctuation(propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT, propositionFournisseur(produit)?.prixActif?.prixUnitaireHT) > 0}]"></i> ({{ afficherPourcentageFluctuation(propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT, propositionFournisseur(produit)?.prixActif?.prixUnitaireHT) }})</div>
                            </td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)">
                              <span>{{ afficherPCBetUC(propositionFournisseur(produit)?.prixActif?.pcb, produit.uniteCotation) }}</span>
                            </td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)">
                              {{ afficherPrixPcbUc(propositionFournisseur(produit)?.prixActif?.prixUnitaireHT, propositionFournisseur(produit)?.prixActif?.pcb, produit.uniteCotation) }}
                            </td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)">
                              {{ propositionFournisseur(produit)?.prixActif?.uniteFacturation }}
                            </td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)">
                              {{ propositionFournisseur(produit)?.prixActif?.uniteCommandeEDI }}
                            </td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)"></td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)"></td>
                            <td v-no-dragdrop @click="selectionnerProduit(produit.produitAgapId)">
                              <button title="Duplique les données du tarif actif sur la proposition, hors prix." :disabled="!propositionEstVide(propositionFournisseur(produit)?.propositionEnCours) || propositionEstVide(propositionFournisseur(produit)?.prixActif) || !estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="btn btn-primary btn-sm" @click="selectionnerProduit(produit.produitAgapId); alimenterProposition(propositionFournisseur(produit)?.propositionEnCours, propositionFournisseur(produit)?.prixActif)"><i class="fas fa-clone"></i></button> 
                            </td>
                          </tr>
                          <template v-for="(proposition, iProposition) in propositionFournisseur(produit)?.historiquePropositions.slice(0, -1)">
                            <tr v-if="filtres.afficherHistoriquePropositions.selection" :key="'histoPropo-'+'ssCat'+iCategorie+'categ'+iSousCategorie+'prod'+iProduit+'propo'+iProposition">
                              <!-- Ligne des historiques des propositions -->
                              <td v-no-dragdrop class="ligne-desactivee aligner-gauche" @click="selectionnerProduit(produit.produitAgapId)" >
                                {{ proposition.designation }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ proposition.reference }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ proposition.marque }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ proposition.prixUnitaireHT | afficherPrix }} / {{ produit.uniteCotation }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ afficherPCBetUC(proposition.pcb, produit.uniteCotation) }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ afficherPrixPcbUc(proposition.prixUnitaireHT, proposition.pcb, produit.uniteCotation) }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ proposition.uniteFacturation }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ proposition.uniteCommandeEDI }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ proposition.commentaireFournisseur }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)"></td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)"></td>
                            </tr>
                            <tr v-if="filtres.afficherHistoriquePropositions.selection && proposition.retourAgap" :key="'histoPropoAgap-'+'ssCat'+iCategorie+'categ'+iSousCategorie+'prod'+iProduit+'propo'+iProposition" :style="'background-color:#E0E0E0'">
                              <td v-no-dragdrop colspan="11" class="aligner-gauche ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ proposition.retourAgap }}
                              </td>
                            </tr>
                          </template>
                          <!-- Ligne de la derniere proposition -->
                          <tr v-if="propositionFournisseur(produit)?.derniereProposition" :key="'dernierePropo-'+'ssCat'+iCategorie+'categ'+iSousCategorie+'prod'+iProduit">
                              <!-- Ligne de la proposition précédente -->
                              <td v-no-dragdrop class="ligne-desactivee aligner-gauche" @click="selectionnerProduit(produit.produitAgapId)" >
                                {{ propositionFournisseur(produit)?.derniereProposition.designation }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ propositionFournisseur(produit)?.derniereProposition.reference }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ propositionFournisseur(produit)?.derniereProposition.marque }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ propositionFournisseur(produit)?.derniereProposition.prixUnitaireHT | afficherPrix }} / {{ produit.uniteCotation }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ afficherPCBetUC(propositionFournisseur(produit)?.derniereProposition.pcb, produit.uniteCotation) }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ afficherPrixPcbUc(propositionFournisseur(produit)?.derniereProposition.prixUnitaireHT, propositionFournisseur(produit)?.derniereProposition.pcb, produit.uniteCotation) }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ propositionFournisseur(produit)?.derniereProposition.uniteFacturation }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ propositionFournisseur(produit)?.derniereProposition.uniteCommandeEDI }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)">
                                {{ propositionFournisseur(produit)?.derniereProposition.commentaireFournisseur }}
                              </td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)"></td>
                              <td v-no-dragdrop class="ligne-desactivee" @click="selectionnerProduit(produit.produitAgapId)"></td>
                            </tr>
                          <!-- Ligne des propositions à saisir -->
                          <tr v-if="estVisible(produit)" :class="[{'ligne-modifiee':estModifie(produit)}]" :key="'proposition-'+'ssCat'+iCategorie+'categ'+iSousCategorie+'prod'+iProduit" :style="'background-color:' + couleurHexCss(propositionFournisseur(produit)?.propositionEnCours?.couleur, 25)"> <!-- :style="produit.propositionEnCours?.couleur ? ('background-color:#' + produit.propositionEnCours.couleur) : ''" -->
                            <td v-no-dragdrop class="aligner-gauche" :style="styleBordure('border', produit, 1, 10)" :class="[{'champ-modifie':valeurEstModifiee('designation', produit)}]" @click="deplacerCurseur(produit.produitAgapId, 0)">
                              <span v-if="estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="flex-center-space-between">
                                <input :id="'col0' + produit.produitAgapId" type="text"  class="form-control mr-1" v-model.trim.lazy="propositionFournisseur(produit).propositionEnCours.designation" maxlength="80" @focus="$event.target.select()" @keyup="deplacerCurseurTexte(produit.produitAgapId, 0, $event)">
                                <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit).propositionEnCours.designation, propositionFournisseur(produit)?.propositionEnCours?.designationObligatoire)"></i>
                              </span>
                              <span v-else>{{ propositionFournisseur(produit)?.propositionEnCours?.designation }}</span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)" :class="[{'champ-modifie':valeurEstModifiee('reference', produit)}]" @click="deplacerCurseur(produit.produitAgapId, 1)">
                              <span v-if="estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="flex-center-space-between">
                                <input :id="'col1' + produit.produitAgapId" type="text" class="form-control" v-model.trim.lazy="propositionFournisseur(produit).propositionEnCours.reference" maxlength="80" @focus="$event.target.select()" @keyup="deplacerCurseurTexte(produit.produitAgapId, 1, $event)">
                                <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit).propositionEnCours.reference, propositionFournisseur(produit)?.propositionEnCours?.referenceObligatoire)"></i>
                              </span>
                              <span v-else>{{ propositionFournisseur(produit)?.propositionEnCours?.reference }}</span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)" :class="[{'champ-modifie':valeurEstModifiee('marque', produit)}]" @click="deplacerCurseur(produit.produitAgapId, 2)">
                              <span v-if="estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="flex-center-space-between">
                                <input :id="'col2' + produit.produitAgapId" type="text" class="form-control" v-model.trim.lazy="propositionFournisseur(produit).propositionEnCours.marque" maxlength="80" @focus="$event.target.select()" @keyup="deplacerCurseurTexte(produit.produitAgapId, 2, $event)">
                                <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit).propositionEnCours.marque, propositionFournisseur(produit)?.propositionEnCours?.marqueObligatoire)"></i>
                              </span>
                              <span v-else>{{ propositionFournisseur(produit)?.propositionEnCours?.marque }}</span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)" :class="[{'champ-modifie':valeurEstModifiee('prixUnitaireHT', produit)}]" @click="deplacerCurseur(produit.produitAgapId, 3)">
                              <label v-if="estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="flex-end h-100 p-0 m-0">
                                <span class="flex-center-space-between">
                                  <InputNumber :id="'col3' + produit.produitAgapId" class="form-control" v-model="propositionFournisseur(produit).propositionEnCours.prixUnitaireHT" :data-lignepid="produit.produitAgapId" typeFiltre="montant" decimales="6" maxLength="11" :zeroSiVide="false" :fixBlur="true" @move="deplacerCurseur(produit.produitAgapId, 3, $event)" @focus="selectionnerProduit(produit.produitAgapId)" />
                                  <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit).propositionEnCours.prixUnitaireHT, propositionFournisseur(produit)?.propositionEnCours?.prixObligatoire)"></i>
                                  <span class="input-group-text bg-transparent">€ / {{ produit.uniteCotation }}</span>
                                </span>
                              </label>
                              <span v-else>{{ propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT | afficherPrix }}</span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)" :class="[{'champ-modifie':valeurEstModifiee('pcb', produit)}]" @click="deplacerCurseur(produit.produitAgapId, 4)">
                              <label v-if="estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="flex-end h-100 p-0 m-0">
                                <span class="flex-center-space-between">
                                  <InputNumber :id="'col4' + produit.produitAgapId" class="form-control" v-model="propositionFournisseur(produit).propositionEnCours.pcb" :data-lignepid="produit.produitAgapId" typeFiltre="quantite" maxLength="11" :zeroSiVide="false" :fixBlur="true" @move="deplacerCurseur(produit.produitAgapId, 4, $event)" @focus="selectionnerProduit(produit.produitAgapId)" />
                                  <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit).propositionEnCours.pcb, propositionFournisseur(produit)?.propositionEnCours?.pcbObligatoire)"></i>
                                  <span class="input-group-text bg-transparent">{{ produit.uniteCotation }}</span>
                                </span>
                              </label>
                              <span v-else>{{ afficherPCBetUC(propositionFournisseur(produit)?.propositionEnCours?.pcb, produit.uniteCotation) }}</span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)" @click="deplacerCurseur(produit.produitAgapId, 5)">
                              {{ afficherPrixPcbUc(propositionFournisseur(produit)?.propositionEnCours?.prixUnitaireHT, propositionFournisseur(produit)?.propositionEnCours?.pcb, produit.uniteCotation) }}
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)" :class="[{'champ-modifie':valeurEstModifiee('uniteFacturation', produit)}]" @click="deplacerCurseur(produit.produitAgapId, 5)">
                              <span v-if="estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="flex-center-space-between">
                                <input :id="'col5' + produit.produitAgapId" type="text" class="form-control" v-model.trim.lazy="propositionFournisseur(produit).propositionEnCours.uniteFacturation" maxlength="80" @focus="$event.target.select()" @keyup="deplacerCurseurTexte(produit.produitAgapId, 5, $event)">
                                <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit).propositionEnCours.uniteFacturation, propositionFournisseur(produit)?.propositionEnCours?.uniteFacturationFournisseurObligatoire)"></i>
                              </span>
                              <span v-else>{{ propositionFournisseur(produit)?.propositionEnCours?.uniteFacturation }}</span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)" :class="[{'champ-modifie':valeurEstModifiee('uniteCommandeEDI', produit)}]" @click="deplacerCurseur(produit.produitAgapId, 6)">
                              <span v-if="estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="flex-center-space-between">
                                <input :id="'col6' + produit.produitAgapId" type="text" class="form-control" v-model.trim.lazy="propositionFournisseur(produit).propositionEnCours.uniteCommandeEDI" maxlength="80" @focus="$event.target.select()" @keyup="deplacerCurseurTexte(produit.produitAgapId, 6, $event)">
                                <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit).propositionEnCours.uniteCommandeEDI, propositionFournisseur(produit)?.propositionEnCours?.ucediFournisseurObligatoire)"></i>
                              </span>
                              <span v-else>{{ propositionFournisseur(produit)?.propositionEnCours?.uniteCommandeEDI }}</span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)" :class="[{'champ-modifie':valeurEstModifiee('commentaireFournisseur', produit)}]" @click="deplacerCurseur(produit.produitAgapId, 7)">
                              <span v-if="estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="flex-center-space-between">
                                <input :id="'col7' + produit.produitAgapId" type="text" class="form-control" v-model.trim.lazy="propositionFournisseur(produit).propositionEnCours.commentaireFournisseur" maxlength="250" @focus="$event.target.select()" @keyup="deplacerCurseurTexte(produit.produitAgapId, 7, $event)">
                                <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit).propositionEnCours.commentaireFournisseur, propositionFournisseur(produit)?.propositionEnCours?.commentaireFournisseurObligatoire)"></i>
                              </span>
                              <span v-else>{{ propositionFournisseur(produit)?.propositionEnCours?.commentaireFournisseur }}</span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10)">
                              <span v-if="!propositionEstVide(propositionFournisseur(produit)?.propositionEnCours)" class="flex-center-space-between">
                                <button :disabled="AucuneFicheTechnique(produit)" 
                                        class="btn btn-primary btn-sm" 
                                        @click="ouvrirFicheTechnique((PropositionAUneFicheTechnique(produit) ? produit : null), propositionFournisseur(produit)?.prixActif?.ficheTechniqueId)"><i class="fas fa-eye"></i>
                                </button>
                                <button :disabled="!propositionFournisseur(produit)?.propositionEnCours?.reference || !estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="btn btn-primary btn-sm" :title="'Importer la fiche technique pour la référence ' + propositionFournisseur(produit)?.propositionEnCours?.reference" @click="importerUneFicheTechnique(produit)"><i class="fas fa-upload"></i></button>
                                <i title="Valeur obligatoire" :class="champObligatoire(produit, propositionFournisseur(produit)?.ftPropositionOK, propositionFournisseur(produit)?.propositionEnCours?.ftObligatoire)"></i>
                              </span>
                            </td>
                            <td v-no-dragdrop :style="styleBordure('border', produit, 1, 10, false)">
                              <button :disabled="(propositionEstVide(propositionFournisseur(produit)?.propositionEnCours) && !(afficherErreurs && estVisible(produit) && propositionFournisseur(produit)?.retourAgap)) || !estModifiable(propositionFournisseur(produit)?.propositionEnCours)" class="btn btn-danger btn-sm" @click="selectionnerProduit(produit.produitAgapId); viderProposition(propositionFournisseur(produit))"><i class="fas fa-trash"></i></button> 
                            </td>
                          </tr>
                          <!-- Ligne du ou des messages d'erreur de la proposition -->
                          <tr v-if="(afficherErreurs && estVisible(produit) && propositionFournisseur(produit)?.retourAgap) || (listeErreurSuiteEnvoie(propositionFournisseur(produit)?.propositionEnCours) !== '')" :key="'agap-'+'ssCat'+iCategorie+'categ'+iSousCategorie+'prod'+iProduit" :style="'background-color:' + couleurHexCss(propositionFournisseur(produit)?.propositionEnCours?.couleur, 15)">
                            <td v-no-dragdrop colspan="11" :class="['aligner-gauche', {'text-error':estModifiable(propositionFournisseur(produit)?.propositionEnCours)}, {'text-note':!estModifiable(propositionFournisseur(produit)?.propositionEnCours)}]" :style="styleBordure('border', produit, 1, 10)" @click="selectionnerProduit(produit.produitAgapId)">
                              {{ propositionFournisseur(produit)?.retourAgap }} {{ listeErreurSuiteEnvoie(propositionFournisseur(produit)?.propositionEnCours) }}
                            </td>
                          </tr>
                          <!-- Ligne du ou des messages d'avertissement de la proposition, non affiché si propo en lecture seule -->
                          <tr v-if="(afficherErreurs && estVisible(produit) && propositionFournisseur(produit)?.warningAgap && estModifiable(propositionFournisseur(produit)?.propositionEnCours)) || (listeWarningSuiteEnvoie(propositionFournisseur(produit)?.propositionEnCours) !== '')" :key="'warningAgap-'+'ssCat'+iCategorie+'categ'+iSousCategorie+'prod'+iProduit" :style="'background-color:' + couleurHexCss(propositionFournisseur(produit)?.propositionEnCours?.couleur, 15)">
                            <td v-no-dragdrop colspan="11" class="aligner-gauche text-note" :style="styleBordure('border', produit, 1, 10)" @click="selectionnerProduit(produit.produitAgapId)">
                              <i class="fas fa-exclamation-triangle text-warning mr-2"></i>{{ propositionFournisseur(produit)?.warningAgap }} {{ listeWarningSuiteEnvoie(propositionFournisseur(produit)?.propositionEnCours) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import BarreFiltres from '@/components/Divers/BarreFiltres'
import BarreActions from '@/components/Divers/BarreActions'
import BarreInformations from '@/components/Divers/BarreInformations'
import InputNumber from '@/components/Inputs/InputNumber'
import ModalImportFichierCotation from '../components/ModalImportFichierCotation.vue'
import ModalImportFichesTechniques from '../components/ModalImportFichesTechniques.vue'
import ModalControleLienFicheTechnique from '../components/ModalControleLienFicheTechnique.vue'
import ModalImportFichesTechniquesGlobal from '../components/ModalImportFichesTechniquesGlobal.vue'
import ModalAfficheDetailFT from '../components/ModalAfficheDetailFT.vue'
import { connecteData } from "@/mixins/connecteData"
import { alerteDonneesModifiees } from "@/mixins/index"
import { obtenirStatutsPropositions, obtenirDatesPropositionsOuvertes, obtenirFamillesProposition, obtenirPropositions, enregistrerPropositions, envoyerPropositions, obtenirTrameCotation, obtenirFicheTechnique, obtenirUneFicheTechnique } from '@/api/gpao/propositions'
import { formatHumanDateAvecSlashes, formatageDate } from '../mixins/dateFormats'
import { arrondiMercuriale, plurielUC, arrondiPrixPCB, Nombre, deplacerCurseur, calculerIndiceDeplacement, convertirPourcentageToHex, rechercherMultiTexte, arrondiPourcentageDifference, creerMessageBarreInformation } from '../helpers/utils'
import { saveAs } from 'file-saver'
import _ from 'lodash'
import couleurs from '@/assets/css/couleurs.scss'


export default {
  name: "PropositionsMercuComparative",
  mixins: [ connecteData, alerteDonneesModifiees, formatHumanDateAvecSlashes, formatageDate ],
  props: {propositionId: Number, familleId: Number },
  components: {
    BarreFiltres,
    BarreActions,
    BarreInformations,
    InputNumber,
    ModalImportFichierCotation,
    ModalImportFichesTechniques,
    ModalImportFichesTechniquesGlobal,
    ModalControleLienFicheTechnique,
    ModalAfficheDetailFT
  },
  data() {
    return {
      key: 0,
      selectedFile: null,
      formData: null,
      propoArticleFournId: null,
      propoDesignation: null,
      propoReference: null,
      statuts: [],
      propositionSelectionnee: null,
      familleSelectionnee: null,
      donneesInitiales: null,
      tableauPropositions: null,
      produitSelectionneId: null,
      listeProduitsModifies: [],
      afficherDatesFermees: false,
      messageImportFicheTechnique: "",
      listeErreurEnvoiePropositions: [],
      importFicheTechniqueTermine: true,
      barreInformationAffichee: false,
      blobFt: null,
      filtres: {
        dateActivation: {
          label: "Date d'application",
          champ: "select",
          width: "210px",
          options: [],
          selection: null,
          initialiser(contexte, options) {
            contexte.filtres.dateActivation.options = options
          },
          async filtrer(contexte) {
            let filtreDateActivation = contexte.filtres.dateActivation

            if (filtreDateActivation.selection.valeur < 0) {
              filtreDateActivation.selection = contexte.propositionSelectionnee
              contexte.chargerDatesPropositions(contexte.fournisseurCourantId, !contexte.afficherDatesFermees)
            } else {
              if (!await contexte.checkDonneesModifiees())
                return

              contexte.propositionSelectionnee = filtreDateActivation.selection
              contexte.chargerFamilles(contexte.fournisseurCourantId, filtreDateActivation.selection?.valeur)
              contexte.filtres.statuts.initialiser(contexte, null) 													  

              // Gestion des accès de l'export de trame
              contexte.actions.exporterTrame.disabled = false
              contexte.actions.controlerLiensFichesTechniques.disabled = true
              if (filtreDateActivation.selection?.ouvertePourSaisie) {
                contexte.actions.importerPropositions.disabled = false
                contexte.actions.importerFT.disabled = false
                contexte.actions.envoyerPropositions.disabled = false
              } else {
                contexte.actions.importerPropositions.disabled = true
                contexte.actions.importerFT.disabled = true
                contexte.actions.envoyerPropositions.disabled = true
              }
            }
          }
        },
        afficherHistoriquePropositions: {
          label: "Afficher historique",
          champ: "checkbox",
          selection: false,
          filtrer() {}
        },
        familles: {
          label: "Familles",
          champ: "select",
          width: "235px",
          options: [],
          selection: null,
          initialiser(contexte, options) {
            let filtreFamilles = contexte.filtres.familles

            filtreFamilles.options = options
            // Sélection automatique de la 1ère famille si la liste n'est pas vide (elle correspond à la seule famille disponible s'il n'y en a qu'une ou à "Toutes familles" s'il y en a plusieurs)
            filtreFamilles.selection = filtreFamilles.options?.length ? filtreFamilles.options[0] : null

            contexte.filtres.statuts.initialiser(contexte, [])
            filtreFamilles.filtrer(contexte)
          },
          async filtrer(contexte) {
            let filtreFamilles = contexte.filtres.familles

            // Gestion des données modifiées pour permettre l'enregistrement avant de changer de famille et perdre la saisie de l'utilisateur
            if (!await contexte.checkDonneesModifiees()) {
              filtreFamilles.selection = contexte.familleSelectionnee
              return
            }
            
            contexte.messageImportFicheTechnique = ""
            contexte.familleSelectionnee = filtreFamilles.selection
            contexte.actions.exporterTrame.label = "Exporter " + (filtreFamilles.selection?.texte ?? "")
            contexte.actions.exporterTrame.tooltip = "Exporter la trame de cotation pour " + filtreFamilles.selection?.texte
            contexte.actions.envoyerPropositions.label = "Envoyer les propositions " + (filtreFamilles.selection?.texte ?? "")
            contexte.actions.envoyerPropositions.tooltip = "Envoyer les propositions au service Achats pour " + filtreFamilles.selection?.texte
            
            let propositionId = contexte.filtres.dateActivation.selection?.valeur
            let familleId = filtreFamilles.selection?.valeur

            if (propositionId && familleId) {
              // Chargement des propositions de la famille
              contexte.chargerPropositions(contexte.fournisseurCourantId, propositionId, familleId)
              contexte.actions.controlerLiensFichesTechniques.disabled = false
            } else {
              // Gestion du choix "Toutes familles"
              contexte.filtres.statuts.initialiser(contexte, null)
              contexte.tableauPropositions = null
              contexte.donneesInitiales = null
            }

            // Gestion des accès des actions qui nécessitent une famille
            if (!contexte.filtres.dateActivation.selection?.ouvertePourSaisie || filtreFamilles.selection?.ouvertePourSaisie === false) {
              // 
              contexte.actions.importerPropositions.disabled = true
              contexte.actions.importerFT.disabled = true
              contexte.actions.envoyerPropositions.disabled = true
              contexte.actions.controlerLiensFichesTechniques.disabled = true
            } else {
              // Cas de la sélection d'une famille spécifique
              contexte.actions.importerPropositions.disabled = false
              contexte.actions.importerFT.disabled = false
              contexte.actions.envoyerPropositions.disabled = false
              //contexte.actions.controlerLiensFichesTechniques.disabled = false
            }
          }
        },
        statuts: {
          label: "Statuts de propositions",
          champ: "select",
          width: "330px",
          options: [],
          selection: null,
          initialiser(contexte, options) {
            let filtreStatuts = contexte.filtres.statuts
            filtreStatuts.options = options
            // On sélectionne par défaut le 1er statut avec propositions modifiables, et s'il n'y en a pas, on sélectionne le 1er statut disponible non final
            filtreStatuts.selection = options?.filter(o => o.modifiable)?.length ? options.filter(o => o.modifiable)[0] : options?.filter(o => !o.final)?.length ? options?.filter(o => !o.final)[0] : options?.length ? options[0] : null
          },
          filtrer(contexte, produit) {
            let filtreStatuts = contexte.filtres.statuts
            if (!filtreStatuts.selection) {
              // Aucun statut n'est sélectionné, on n'affiche aucune proposition
              return false
            }
            if (filtreStatuts.selection.valeur === 0) {
              // Cas du filtre sur les propositions en erreur de conformité
              return !contexte.propositionEstConforme(contexte.propositionFournisseur(produit)?.propositionEnCours) || contexte.propositionEstWarning(contexte.propositionFournisseur(produit)) || (contexte.propositionFournisseur(produit)?.retourAgap !== "" && !contexte.propositionFournisseur(produit)?.propositionEnCours.enLectureSeule) || contexte.listePropositionIdErreurEnvoieFamilleSelectionnee.some(e => e.propositionArticleFournisseurId === contexte.propositionFournisseur(produit)?.propositionEnCours.id && e.erreurGenerique !== "")
            }
            if (!Nombre(filtreStatuts.selection.valeur)) {
              // remarque : on distingue  des erreurs de FT Azure de propos qui ont le même libellé, en erreurs bloquantes (si le lien FT du prix Actif n'existe pas) de celles non bloquantes (si le lien FT du prix Actif existe)
              return (contexte.propositionFournisseur(produit)?.retourAgapPourFiltre.includes(filtreStatuts.selection.valeur) && !filtreStatuts.selection.warning) || 
                     (contexte.propositionFournisseur(produit)?.warningAgapPourFiltre.includes(filtreStatuts.selection.valeur) && filtreStatuts.selection.warning) ||
                     contexte.listePropositionIdErreurEnvoieFamilleSelectionnee.some(e => e.propositionArticleFournisseurId === contexte.propositionFournisseur(produit)?.propositionEnCours.id && e.erreurGenerique === filtreStatuts.selection.valeur) ||
                     contexte.listePropositionIdWarningEnvoieFamilleSelectionnee.some(e => e.propositionArticleFournisseurId === contexte.propositionFournisseur(produit)?.propositionEnCours.id && e.erreurGenerique === filtreStatuts.selection.valeur) 
            }
            if (filtreStatuts.selection.valeur < 0) {
              //filtres basés sur une méthode
              return filtreStatuts.selection.methode(produit)
            }

            return contexte.propositionFournisseur(produit)?.propositionEnCours?.statutId === filtreStatuts.selection.valeur
          }
        },
        designationsProduit: {
          label: "Recherche produits",
          champ: "input",
          type: "text",
          width: "240px",
          selection: "",
          class: "search",
          filtrer(contexte, produit) {
            let propositionFournisseur = contexte.propositionFournisseur(produit)
            let designationsProduit = propositionFournisseur ? produit.codeProduitAgap + " " + produit.nomProduitAgap + " " + propositionFournisseur.prixActif?.designation + " " + propositionFournisseur.prixActif?.reference + " " + propositionFournisseur.prixActif?.marque + " " +
              propositionFournisseur.propositionEnCours?.designation + " " + propositionFournisseur.propositionEnCours?.reference + " " + propositionFournisseur.propositionEnCours?.marque : ""
            return rechercherMultiTexte(designationsProduit, contexte.filtres.designationsProduit.selection)
          }
        },
        // Appeler "this.filtres.initialiser(this)" dans mounted() => génère le tableau de filtres utilisés pour afficher les filtres dans la barre de filtres
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.filtres.barreGauche = [ contexte.filtres.dateActivation, contexte.filtres.familles, contexte.filtres.statuts ]
          contexte.filtres.barreDroite = [ contexte.filtres.designationsProduit, contexte.filtres.afficherHistoriquePropositions ]
          contexte.filtres.barreGauche.forEach(f => {
            if (f.initialiser) {
              f.initialiser(contexte)
            }
          })
        }
      },
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        exporterTrame: {
          label: "Exporter",
          disabled: true,
          async methode(contexte) {
            if (contexte.donneesModifiees) {
              let response = await contexte.alerteConfirmation("Modifications en cours", "Attention, vos modifications en cours ne seront pas prises en compte dans l'export, nous préconisons d'enregistrer vos modifications avant l'export. Souhaitez-vous continuer ?")
              if (!response)
                return
            }
            // Appeler l'API d'export des trames
            contexte.exporterTrameCotation()
          }
        },
        importerPropositions: {
          label: "Importer Propositions",
          tooltip: 'Importer une ou plusieurs trames de cotations',
          disabled: true,
          async methode(contexte) {
            if (contexte.donneesModifiees) {
              let response = await contexte.alerteConfirmation("Modifications en cours", "Attention, vos modifications en cours seront perdues. Souhaitez-vous continuer ?")
              if (!response)
                return
            }
            contexte.selectedFile=null
            contexte.formData=null
            contexte.ouvrirModalChargementFichier()
            //contexte.$refs.importCotations.click()
            // Appeler l'API d'import des propositions fournisseurs
          }
        },
        importerFT: {
          label: "Importer FT (100 Mo maximum)",
          tooltip: 'Importer un PDF ou un ZIP de fiches techniques',
          disabled: true,
          methode(contexte) {
            contexte.selectedFile=null
            contexte.formData=null
            contexte.propoArticleFournId = null
            contexte.key++
            contexte.ouvrirModalChargementFicheTechnique()
            // Appeler l'API d'import des fiches techniques fournisseurs
          }
        },
        envoyerPropositions: {
          label: "Envoyer les propositions",
          disabled: true,
          class: "btn-success",
          methode(contexte) {
            contexte.envoyerPropositions()
          }
        },
        controlerLiensFichesTechniques: {
          label: "Vérifier les liens de fiches techniques",
          disabled: true,
          methode(contexte) {
            contexte.ControlerLiensFichesTechniques()
          }
        },
        annuler: {
          label: "Annuler",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            contexte.tableauPropositions = _.cloneDeep(contexte.donneesInitiales)
            contexte.listeProduitsModifies = []
          }
        },
        enregistrer: {
          label: "Enregistrer",
          disabled: true,
          class: "btn-success",
          methode(contexte) {
            contexte.enregistrerDonneesModifiees()
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ contexte.actions.exporterTrame, contexte.actions.importerPropositions, contexte.actions.importerFT, contexte.actions.controlerLiensFichesTechniques, contexte.actions.envoyerPropositions ]
          contexte.actions.barreDroite = [ contexte.actions.annuler, contexte.actions.enregistrer ]
        }
      }
    }
  },
  computed: {
    // Variable utilisée pour afficher les messages dans la barre d'informations
    informations() {
      let messagesGauche = []
      if (this.messageImportFicheTechnique) {
        messagesGauche.push(creerMessageBarreInformation((!this.importFicheTechniqueTermine ? "fas fa-spinner fa-spin" : this.listeErreurFicheTechnique?.length ? "fas fa-exclamation-triangle text-warning" : "fas fa-check-circle text-success"), this.messageImportFicheTechnique, null))
        if (this.importFicheTechniqueTermine && this.listeErreurFicheTechnique?.length) {
          messagesGauche.push(creerMessageBarreInformation(null, "Voir erreurs", "btn btn-primary btn-sm", () => { this.afficherDetailImportFicheTechnique() }))
        }
      }

      let messagesCentre = []
      if (this.periodeFamilleEstModifiable()) {
        messagesCentre.push(creerMessageBarreInformation(null, "Saisie des propositions ouverte jusqu'au ", null))
        messagesCentre.push(creerMessageBarreInformation(null, this.formatHumanDateAvecSlashes(this.tableauPropositions?.dateFinAcces), "bold600"))
      } else if (!this.toutesPropositionsModifiablesParAgap(this.tableauPropositions)) {
        messagesCentre.push(creerMessageBarreInformation("fas fa-exclamation-triangle text-error", "La mise à jour tarifaire n'est plus possible pour cette famille à cette date. Merci de contacter le service achats.", "text-error bold600"))
      }

      let messagesDroite = []
      if (this.afficherTableauPropositions && this.periodeFamilleEstModifiable()) {
        messagesDroite.push(creerMessageBarreInformation(null, "La variation globale des tarifs de cette famille est de ", null))
        messagesDroite.push(creerMessageBarreInformation(null, this.afficherPCBetUC(this.totaleVariations(),'') + " €", "bold600 " + (this.totaleVariations() < 0 ? "text-success" : this.totaleVariations() > 0 ? "text-error" : "")))
        messagesDroite.push(creerMessageBarreInformation(null, " soit ", null))
        messagesDroite.push(creerMessageBarreInformation(null, this.afficherPourcentageVariationTotale(), "bold600 " + (this.totaleVariations() < 0 ? "text-success" : this.totaleVariations() > 0 ? "text-error" : "")))
      }

      return {
        messagesGauche: messagesGauche,
        messagesCentre: messagesCentre,
        messagesDroite: messagesDroite
      }
    },
    afficherTableauPropositions() {
      return this.tableauPropositions ?? false
    },
    donneesModifiees() {
      return this.listeProduitsModifies?.length || (this.donneesInitiales && this.tableauPropositions && !_.isEqual(JSON.stringify(this.donneesInitiales), JSON.stringify(this.tableauPropositions)))
    },
    dateIdSelectionnee() {
      return this.filtres.dateActivation.selection ? this.filtres.dateActivation.selection.valeur : 0
    },
    familleIdSelectionnee() {
      return this.filtres.familles.selection?.valeur ?? 0
    },
    nomFamilleSelectionnee() {
      return this.filtres.familles.selection?.texte ?? ""
    },
    propoArticleSelectionnee() {
      this.key
      return this.propoArticleFournId
    },
    propoDesignationSelectionnee() {
      this.key
      return this.propoDesignation
    },
    propoReferenceSelectionnee() {
      this.key
      return this.propoReference
    },
    contenuDuFichier() {
      return this.formData ?? new FormData()
    },
    nomDuFichier() {
      return this.selectedFile?.name ?? ""
    },
    listeLiensFicheTechnique() {
      this.key
      return this.tableauPropositions ? this.listeProduits(this.tableauPropositions).map(m => {
        return this.propositionFournisseur(m)
      }).filter(p => p.propositionEnCours?.lienFicheTechnique) : null;
    },
    listeErreurFicheTechnique() {
      this.key
      return this.listeLiensFicheTechnique?.filter(p => !p.propositionEnCours?.ficheTechniqueAzureOk);
    },
    listeErreurEnvoie() {
      this.key
      return this.listeErreurEnvoiePropositions;
    },
    listeErreurEnvoieFamilleSelectionnee() {
      this.key
      let listeErreur = this.listeErreurEnvoiePropositions?.filter(x => x.familleId === this.familleIdSelectionnee) || []
      if (listeErreur.length > 0)
        return listeErreur.first().listeDetailErreurs?.filter(x => !x.warning) || [];
      else
        return []
    },
    listeWarningEnvoieFamilleSelectionnee() {
      this.key
      let listeErreur = this.listeErreurEnvoiePropositions?.filter(x => x.familleId === this.familleIdSelectionnee) || []
      if (listeErreur.length > 0)
        return listeErreur.first().listeDetailErreurs?.filter(x => x.warning) || [];
      else
        return []
    },
    listePropositionIdWarningEnvoieFamilleSelectionnee() {
      return this.listeWarningEnvoieFamilleSelectionnee.map(x => { return {propositionArticleFournisseurId: x.propositionArticleFournisseurId, erreurGenerique: x.erreurGenerique}} )
    },
    listePropositionIdErreurEnvoieFamilleSelectionnee() {
      return this.listeErreurEnvoieFamilleSelectionnee.map(x => {return {propositionArticleFournisseurId: x.propositionArticleFournisseurId, erreurGenerique: x.erreurGenerique}} )
    },
    blobFicheTechnique() {
      return this.blobFt ?? new Blob()
    },
    afficherErreurs() {
      return this.tableauPropositions?.afficherErreurs || false
    },
    totalPrixParCategorie() {
      //retourne le total des prix Actifs par categorie et le total des prix des propositions, afin de calculer la variation par categorie
      
      let totalCategorie = this.tableauPropositions ? this.tableauPropositions.categories?.map(c => {
        let totalPropo = 0
        let totalActif = 0
        let pf = c.sousCategories?.map(s => s.produits).reduce((a, b) => a.concat(b), []).map(p => p.propositionsFournisseurs).reduce((a, b) => a.concat(b), []) || []
        
        pf.forEach(p => {
          if (!this.propositionEstVide(p.propositionEnCours) && p.propositionEnCours.prixUnitaireHT && p.prixActif) {
            totalPropo += p.propositionEnCours?.prixUnitaireHT
            totalActif += p.prixActif?.prixUnitaireHT ?? 0
          }
        })
        
        let ret = {
          categorieId: c.categorieId,
          totalPropo: totalPropo,
          totalActif: totalActif
        }
        return ret;
      }) : null
      return totalCategorie
    }
  },
  watch: {
    afficherTableauPropositions() {
      /*if (this.afficherTableauPropositions) {
        this.actions.controlerLiensFichesTechniques.disabled = false
      } else {
        this.actions.controlerLiensFichesTechniques.disabled = true
      }*/
      //this.actions.disableBoutonsPropositions(this.actions, !this.afficherTableauPropositions || !this.contientPropositionsModifiables(this.tableauPropositions))
    },
    donneesModifiees() {
      if (this.donneesModifiees) {
        //this.actions.envoyerPropositions.disabled = true
        this.actions.enregistrer.disabled = false
        this.actions.annuler.disabled = false
      } else {
        this.actions.enregistrer.disabled = true
        this.actions.annuler.disabled = true
      }
    }
  },
  async mounted() {
    this.filtres.initialiser(this)
    this.actions.initialiser(this)

    await this.chargerDatesPropositions(this.fournisseurCourantId, false)
    this.chargerStatuts()
    this.messageImportFicheTechnique = ""

    //Si on vient de la page d'accueil via les boutons de l'etat d'avancement
    if (this.$route.query.propositionId && this.$route.query.familleId) {
      //Il faut convertir les parametres recus (qui sont un string) en int pour pouvoir les utiliser directement en tant que filtre
      //sélection de la date
      this.filtres.dateActivation.selection = this.filtres.dateActivation.options.filter(f => f.valeur === parseInt(this.$route.query.propositionId, 10)).first() 
      
      //filtre sur la date et chargement du filtre des familles associé
      await this.filtres.dateActivation.filtrer(this)
      await this.chargerFamilles(this.fournisseurCourantId, parseInt(this.$route.query.propositionId, 10))

      //filtre sur la famille
      this.filtres.familles.selection = this.filtres.familles.options.filter(f => f.valeur === parseInt(this.$route.query.familleId, 10)).first()
      await this.filtres.familles.filtrer(this)
    }

  },
  created() {
    // Déclenche un verrou et un message à la fermeture du navigateur si des données sont en cours de modification (Le message est déclenché si la valeur retournée est différente de null)
    window.onbeforeunload = (() => {
      if (this.donneesModifiees)
        return true
      return null
    })
  },
  methods: {
    /* *************************** METHODE TECHNIQUE ******************************** */
    appliquerFiltre(filtrer) {
      // Nécessaire pour faire fonctionner les filtres de la barre de filtres
      filtrer(this)
    },
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },

    /* **************************** GESTION FICHES TECHNIQUES *********************** */
    ControlerLiensFichesTechniques() {
      //On vérifie s'il existe des liens de FT avec des erreurs Azure, sinon on dit qu'il n'y a rien à faire
      if (this.listeErreurFicheTechnique.length > 0) {
        //await this.copierFichesTechniques(this.fournisseurCourantId, this.dateIdSelectionnee, this.familleIdSelectionnee, 300000) //timeout à 5 minutes
        //this.nombreLienFicheTechnique = this.listeErreurFicheTechnique.length
        //this.key++
        this.$refs.modalControleLienFicheTechnique.show(this.listeErreurFicheTechnique.length)
      } else
        this.alerteWarning("Il n'y a aucun lien de fiche technique en erreur", "Information", "success", couleurs.sucess)
    },

    ouvrirModalChargementFicheTechnique() {
      this.$refs.modalImportFichesTechniquesGlobal.show()
    },
    PropositionAUneFicheTechnique(produit) {
      let statutRefuse = this.statuts.find(x => !x.pourAgap && x.statutIdPrecedent)
      // dans le cas où la propo en cours n'a pas d'Id mais que son CheckSumMD5FicheTechnique est défini et que son StatutId == 3 
      // c'est que la propo vient d'être recréée suite à un refus du service Achat
      // donc dans ce cas là on retourne true également
      return this.propositionFournisseur(produit)?.propositionEnCours?.ficheTechniqueAzureOk && !this.propositionEstVide(this.propositionFournisseur(produit)?.propositionEnCours) && (this.propositionFournisseur(produit)?.propositionEnCours?.id || (!this.propositionFournisseur(produit)?.propositionEnCours?.id && this.propositionFournisseur(produit)?.propositionEnCours?.checkSumMD5FicheTechnique && this.propositionFournisseur(produit)?.propositionEnCours?.statutId === statutRefuse.id))
    },
    AucuneFicheTechnique(produit) {
      return (this.propositionFournisseur(produit)?.propositionEnCours?.erreurAzureFicheTechnique) || ((!this.propositionFournisseur(produit)?.prixActif?.ficheTechniqueId || !this.propositionFournisseur(produit)?.prixActif?.ficheTechniqueAzureOk)  && 
                    (!this.propositionFournisseur(produit)?.propositionEnCours?.ficheTechniqueAzureOk || (this.propositionFournisseur(produit)?.propositionEnCours?.id && !this.propositionEstVide(this.propositionFournisseur(produit)?.propositionEnCours) && !this.propositionFournisseur(produit)?.propositionEnCours?.ficheTechniqueAzureOk)))
    },
    async importerUneFicheTechnique(produit) {
      //Permet d'importer une fiche technique sur une proposition article (id en parametre)
      //ce n'est possible que si les propositions ont été enregistrées afin d'avoir les Id de chaque PropoArticleFournisseur
      //fournisseurId, propositionId, propoArticleId, fichier
      //let ret = await this.importerUneFicheTechnique()

      let propoArticleId = this.propositionFournisseur(produit)?.propositionEnCours?.id

      if (!propoArticleId) {
        if (this.donneesModifiees) {
          let response = await this.alerteConfirmation("Modifications en cours", "Attention, vous devez enregistrer vos modifications avant d'importer une fiche technique. Souhaitez-vous enregistrer maintenant ?")
          if (!response)
            return
        }
        await this.enregistrerDonneesModifiees(true, false)
        //Il faut récupérer la proposition nouvellement enregistré si besoin
        let newProduit = this.listeProduits(this.tableauPropositions).filter(p => p.codeProduitAgap == produit.codeProduitAgap).first()
        propoArticleId = this.propositionFournisseur(newProduit)?.propositionEnCours?.id
        this.propoDesignation = this.propositionFournisseur(newProduit)?.propositionEnCours?.designation
        this.propoReference = this.propositionFournisseur(newProduit)?.propositionEnCours?.reference
      } else {
        this.propoDesignation = this.propositionFournisseur(produit)?.propositionEnCours?.designation
        this.propoReference = this.propositionFournisseur(produit)?.propositionEnCours?.reference
      }
  
      this.selectedFile=null
      this.formData=null
      this.propoArticleFournId = propoArticleId

      this.key++
      this.$refs.importFicheTechnique.click()
    },
    async ouvrirFicheTechnique(produit, ficheTechniqueId) {
      //Ouvre la FT de la propo ou du tarif actif
      var ret;
      if (produit) {
        //Ouvre la FT stockée sur Azure, via le referentiel Mercuriale
        //ce n'est possible que si les propositions ont été enregistrées afin d'avoir les Id de chaque PropoArticleFournisseur
        let propoArticleId = this.propositionFournisseur(produit)?.propositionEnCours?.id

        if (!propoArticleId) {
          if (this.donneesModifiees) {
            let response = await this.alerteConfirmation("Modifications en cours", "Attention, vous devez enregistrer vos modifications avant d'ouvrir une fiche technique. Souhaitez-vous enregistrer maintenant ?")
            if (!response)
              return
          }
          await this.enregistrerDonneesModifiees(true, false)
          //Il faut récupérer la proposition nouvellement enregistré si besoin
          let newProduit = this.listeProduits(this.tableauPropositions).filter(p => p.codeProduitAgap == produit.codeProduitAgap).first()
          propoArticleId = this.propositionFournisseur(newProduit)?.propositionEnCours?.id
        }

        this.propoArticleFournId = propoArticleId
        this.key++

        ret = await obtenirFicheTechnique(this.fournisseurCourantId, propoArticleId)
      } else {
        if (ficheTechniqueId) {
          ret = await obtenirUneFicheTechnique(ficheTechniqueId)  
        }
      }

      if (ret) {
        let blob = new Blob([ret.data], {type: 'application/pdf'})
        let blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl)
      }
    },

    afficherDetailImportFicheTechnique() {
      //Ouvre la modal pour visualiser le detail du chargement des fiches techniques
      this.$refs.modalAfficheDetailFT.show()
    },
    async afficherMessageFicheTechnique(message, etatTermine) {
      //Permet d'indiquer sur la page l'etat de chargement des fiches techniques, appeler depuis le chargement des fichiers de cotation
      await this.chargerErreursDansPropositions()
      if (message) {
        this.messageImportFicheTechnique = message
        this.importFicheTechniqueTermine = etatTermine
      } else {
        this.messageImportFicheTechnique = ""
      }

      this.chargerOptionsStatuts()
      this.key++
    },
    chargerFichesTechniques(event) {
      //Récupération de la ou les fiches techniques depuis le bouton import FT
      //on récupère le fichier à traiter
      if (event.target.files.length != 0) {
        this.formData = new FormData();
        this.selectedFile = event.target.files[0];
        
        if (this.selectedFile.size > (1024 * 1024 * 100)) {
          // Fichier de 100 Mo maximum
          this.alerteErreur("Le fichier que vous tentez d'importer est trop volumineux (" + arrondiMercuriale(this.selectedFile.size / 1024 / 1024) + " Mo). Taille maximale : 100 Mo.")
          return
        }
        
        this.formData.append('fichier', this.selectedFile);
        this.$refs.modalImportFichesTechniques.show()
        this.$refs.importFicheTechnique.value = null
      }
    },
    
    async chargerErreursDansPropositions() {
      //Met à jour le champ d'erreur dans les propositions
      let propositionId = this.filtres.dateActivation.selection?.valeur
      let familleId = this.filtres.familles.selection?.valeur

      
      if (propositionId && familleId) {
        let response = await obtenirPropositions(this.fournisseurCourantId, propositionId, familleId)
        let produitsAJour = this.listeProduits(response.data)
        for (let iCategorie in this.tableauPropositions.categories) {
          let categorie = this.tableauPropositions.categories[iCategorie]
          for (let iSousCategorie in categorie.sousCategories) {
            let sousCategorie = categorie.sousCategories[iSousCategorie]
            for (let iProduit in sousCategorie.produits) {
              let produit = sousCategorie.produits[iProduit]
              let proposition = this.propositionFournisseur(produit)
              let produitAJour = produitsAJour.filter(x => x.codeProduitAgap == produit.codeProduitAgap).shift()
              let propositionAJour = produitAJour ? this.propositionFournisseur(produitAJour) : null
              if (proposition && propositionAJour) {
                proposition.retourAgap = propositionAJour.retourAgap
                proposition.propositionEnCours.ficheTechniqueAzureOk = propositionAJour.propositionEnCours.ficheTechniqueAzureOk
                proposition.propositionEnCours.erreurAzureFicheTechnique = propositionAJour.propositionEnCours.erreurAzureFicheTechnique
                proposition.ftPropositionOK = propositionAJour.ftPropositionOK
                proposition.propositionEnCours.checkSumMD5FicheTechnique = propositionAJour.propositionEnCours.checkSumMD5FicheTechnique ?? ""
                let produitInitial = this.donneesInitiales.categories[iCategorie]?.sousCategories[iSousCategorie]?.produits[iProduit]
                let propositionInitiale = produitInitial ? this.propositionFournisseur(produitInitial) : null
                if (propositionInitiale) {
                  propositionInitiale.retourAgap = propositionAJour.retourAgap
                  propositionInitiale.propositionEnCours.ficheTechniqueAzureOk = propositionAJour.propositionEnCours.ficheTechniqueAzureOk
                  propositionInitiale.propositionEnCours.erreurAzureFicheTechnique = propositionAJour.propositionEnCours.erreurAzureFicheTechnique
                  propositionInitiale.propositionEnCours.checkSumMD5FicheTechnique = propositionAJour.propositionEnCours.checkSumMD5FicheTechnique ?? ""
                  propositionInitiale.ftPropositionOK = propositionAJour.ftPropositionOK
                }
              }
            }
          }
        }
      }
    },

    /* ******************************* GESTION FICHIERS COTATIONS *************************** */
	
    chargerFichierCotation(event) {
      //Traitement du ou des fichiers de cotation via le bouton importer propositions
      //on récupère le fichier à traiter
      if (event.target.files.length != 0) {
        this.formData = new FormData();
        this.selectedFile = event.target.files[0];

        if (this.selectedFile.size > (1024 * 1024 * 100)) {
          // Fichier de 100 Mo maximum
          this.alerteErreur("Le fichier que vous tentez d'importer est trop volumineux (" + arrondiMercuriale(this.selectedFile.size / 1024 / 1024) + " Mo). Taille maximale : 100 Mo.")
          return
        }

        this.formData.append('fichierCotation', this.selectedFile);
        this.$refs.modalImportFichierCotation.show()
        this.$refs.importCotations.value = null
      }
    },
    ouvrirModalChargementFichier() {
      this.$refs.modalImportFichierCotation.show()
    },
    
    async exporterTrameCotation() {
      //Téléchargement du ou des fichiers Excels de demande de cotation sur la ou les familles sélectionnées (Une ou toutes les familles)
      this.$store.commit('uxHelpers/showSpinner')

      let listeFamille = []
      if (this.filtres.familles.selection?.valeur) { //Si on a sélectionné une famille on exporte uniquement celle-ci, sinon on exporte toutes les familles ouvertes sur la proposition
        listeFamille.push(this.filtres.familles.selection.valeur)
      } else {
        listeFamille = this.filtres.familles.options.filter(o => o.valeur).map(o => {
          return o.valeur
        })
      }

      await obtenirTrameCotation(this.fournisseurCourantId, this.filtres.dateActivation.selection.valeur, listeFamille)
        .then(resp => {
          this.$store.commit('uxHelpers/hideSpinner')
          saveAs(new File([resp.data], "DemandeCotation.zip"))
          return
        })

        this.$store.commit('uxHelpers/hideSpinner')
    },

    /* ******************* GESTION DES FILTRES *************************************** */
    
    async chargerStatuts() {
      //Récupère l'ensemble des statuts possible
      let response = await obtenirStatutsPropositions('MCO')
      this.statuts = response.data.filter(s => s.visible)
    },
    async affecterFiltreRecherche(texte, familleId) {
      if (this.filtres.familles.selection.valeur !== familleId) {
        this.filtres.familles.selection = this.filtres.familles.options.filter(f => f.valeur === familleId).first()
        await this.filtres.familles.filtrer(this)
      }
      this.filtres.designationsProduit.selection = texte
    },
    chargerOptionsStatuts() {
      //Formate la liste du filtre Statuts de Propositions
      let produits = this.listeProduits(this.tableauPropositions)
      let statutsProposIds = produits.map(p => this.propositionFournisseur(p)?.propositionEnCours?.statutId)
      let listePropos = produits.map(p => this.propositionFournisseur(p)?.propositionEnCours)

      let statutsIds = [...new Set(statutsProposIds)]
      let optionsStatuts = this.statuts.filter(s => statutsIds.includes(s.id)).map(s => {
        return {
          valeur: s.id,
          texte: s.designationFournisseur + " (" + statutsProposIds.filter(id => id === s.id).length + " / " + produits.length +")",
          style: "color:" + this.couleurHexCss(s.codeCouleur),
          modifiable: !s.pourAgap,
          final: s.statutFinal
        }
      })

      if (this.afficherErreurs) {
        let proposEnErreur = produits.filter(p => this.estModifiable(this.propositionFournisseur(p)?.propositionEnCours) && (!this.propositionEstConforme(this.propositionFournisseur(p)?.propositionEnCours) || this.propositionEstWarning(this.propositionFournisseur(p)) || this.propositionFournisseur(p)?.retourAgap))

        if (proposEnErreur.length) {
          let erreurs = proposEnErreur.filter(o => this.propositionFournisseur(o)?.retourAgap != "").map(p => this.propositionFournisseur(p)?.retourAgapPourFiltre)
          let warning = proposEnErreur.filter(o => this.propositionFournisseur(o)?.warningAgap != "").map(p => this.propositionFournisseur(p)?.warningAgapPourFiltre)

          let erreursDistinct = [...new Set(erreurs)]
          let warningDistinct = [...new Set(warning)]

          let messagesErreurs = []
          erreursDistinct.forEach(e => {
            e.split(" - ").forEach(m => {
              messagesErreurs.push(m)
            })
          })

          let messagesWarning = []
          warningDistinct.forEach(e => {
            e.split(" - ").forEach(m => {
              messagesWarning.push(m)
            })
          })

          let messagesErreursDistinct = [...new Set(messagesErreurs)]
          let messagesWarningDistinct = [...new Set(messagesWarning)]

          messagesErreursDistinct.forEach(e => {
            optionsStatuts.push({
              valeur: e,
              texte: e + " (" + proposEnErreur.filter(p => this.propositionFournisseur(p)?.retourAgapPourFiltre.includes(e)).length + " / " + produits.length + ")",
              style: "color:" + this.couleurHexCss(couleurs.rouge), //"color: red"
              warning: false,
              erreur: true
            })
          })

          messagesWarningDistinct.forEach(e => {
            optionsStatuts.push({
              valeur: e,
              texte: e + " (" + proposEnErreur.filter(p => this.propositionFournisseur(p)?.warningAgapPourFiltre.includes(e)).length + " / " + produits.length + ")",
              style: "color:" + this.couleurHexCss(couleurs.jaune),
              warning: true,
              erreur: false
            })
          })

        }

        let listeErreursEnvoie = []
        let messagesErreursDistinct = []
        //On ajoute les erreurs et warning qui peuvent venir de l'envoie des propositions
        if (this.listeErreurEnvoieFamilleSelectionnee.length > 0 || this.listeWarningEnvoieFamilleSelectionnee.length > 0) {
          //On vérifie que chaque erreur d'envoie est toujours d'actualité
          this.listeErreurEnvoieFamilleSelectionnee.forEach(e => {
            if (listePropos.filter(p => this.controleErreurEnvoie(p, e)).length > 0) {
              listeErreursEnvoie.push(e)
            }
          })

          messagesErreursDistinct = [...new Set(listeErreursEnvoie.map(x => x.erreurGenerique))]
          let messagesWarningDistinct = [...new Set(this.listeWarningEnvoieFamilleSelectionnee.map(x => x.erreurGenerique))]

          messagesErreursDistinct.forEach(e => {
            let proposErreur = [...new Set(this.listeErreurEnvoieFamilleSelectionnee.filter(x => x.erreurGenerique === e).map(x => x.propositionArticleFournisseurId))]
            optionsStatuts.push({
              valeur: e,
              texte: e + " (" + proposErreur.length + ")",
              style: "color:" + this.couleurHexCss(couleurs.rouge),
              warning: false,
              erreur: true
            })
          })

          messagesWarningDistinct.forEach(e => {
            let proposWarning = [...new Set(this.listeWarningEnvoieFamilleSelectionnee.filter(x => x.erreurGenerique === e).map(x => x.propositionArticleFournisseurId))]
            optionsStatuts.push({
              valeur: e,
              texte: e + " (" + proposWarning.length + ")",
              style: "color:" + this.couleurHexCss(couleurs.jaune),
              warning: true,
              erreur: false
            })
          })
        }

        if (proposEnErreur.filter(o => this.propositionFournisseur(o)?.retourAgap != "").length > 0 || messagesErreursDistinct.length > 0) {
          let proposErreur = proposEnErreur.filter(o => this.propositionFournisseur(o)?.retourAgap != "" || this.propositionFournisseur(o)?.warningAgapPourFiltre != "")
          let idProposErreur = [...new Set(proposErreur.map(p => this.propositionFournisseur(p)?.propositionEnCours?.id))]
          let listProposErreur = [...new Set(proposErreur.map(p => this.propositionFournisseur(p)?.propositionEnCours))]
          // Si la liste des idProposErreur ne contient aucun element et que listProposErreur contient des elements, 
          // c'est que le fournisseur envoie les propos (qui contiennent des erreurs) sans avoir fait aucun import et n'a rien modifié
          let proposErreurDistinct = !idProposErreur[0] && listProposErreur.length > 0 ? listProposErreur : idProposErreur
          let idProposErreurEnvoi = [...new Set(listeErreursEnvoie.map(p => p.propositionArticleFournisseurId))]
          // on comptabilise le nombre de propositions DISTINCTES qui contiennent au moins une erreur (d'où qu'elle vienne, envoi propos ou autre)
          let nbErr = [...new Set([...proposErreurDistinct, ...idProposErreurEnvoi])].length
          optionsStatuts.push({
            valeur: 0,
            texte: "Toutes erreurs (" + nbErr + " / " + produits.length + ")",
            style: "color:" + this.couleurHexCss(couleurs.rouge),
            warning: false,
            erreur: true
          })
        }
      }

      //Ajout des filtres propositions modifiées et propositions non modifiées
      //Visible lorsque l'on a un historique de proposition (on travail suite à un retour de l'espace Achat)
      //Ces filtres sont gérés par une méthode

      if (produits.some(p => this.contientValeurModifiee(p))) {
        optionsStatuts.push({
          valeur: -1,
          texte: "Propositions modifiées",
          warning: false,
          erreur: false,
          methode: this.contientValeurModifiee
        })  

        optionsStatuts.push({
          valeur: -2,
          texte: "Propositions non modifiées",
          warning: false,
          erreur: false,
          methode: this.contientValeurNonModifiee
        }) 
      }

      this.filtres.statuts.initialiser(this, optionsStatuts)
    },
    async chargerDatesPropositions(fournisseurId, avecDateFermees) {
      //Récupère les dates d'applications pour lesquelles on demande des cotations
      this.afficherDatesFermees = avecDateFermees
      let response = await obtenirDatesPropositionsOuvertes(fournisseurId, !avecDateFermees)
      let dates = response.data.map(d => {
        return {
          valeur: d.propositionId,
          texte: (!d.ouvertePourSaisie ? "[Fermée] " : "") + this.formatHumanDateAvecSlashes(d.dateActivation) + (d.appelOffre ? !d.ouvertePourSaisie ? " (AO)" : " (Appel d'offre)" : ""),
          class: (d.appelOffre ? "text-danger " : "") + (!d.ouvertePourSaisie ? "inactif" : ""),
          ouvertePourSaisie: d.ouvertePourSaisie
        }
      })
      if (!avecDateFermees) {
        dates.push({
          valeur: -1,
          texte: "",
          icone: "fas fa-caret-down",
          class: "flex-center-space-between"
        })
      } else {
        dates.push({
          valeur: -1,
          texte: "",
          icone: "fas fa-caret-up",
          class: "flex-center-space-between"
        })
      }
      this.filtres.dateActivation.initialiser(this, dates)
    },
    async chargerFamilles(fournisseurId, propositionId) {
      //Récupère la liste des familles possible sur la date d'application sélectionnée
      let response = await obtenirFamillesProposition(fournisseurId, propositionId)
      let familles = response.data.map(f => {
        return {
          valeur: f.familleId,
          texte: (!f.ouvertePourSaisie ? "[Fermée] " : "") + f.nom,
          class: (!f.ouvertePourSaisie ? "inactif" : ""),
          ouvertePourSaisie: f.ouvertePourSaisie
        }
      })
      if (familles?.length > 1) {
        familles.unshift({ valeur: null, texte: "Toutes familles", class: "", ouvertePourSaisie: null })
      }
      this.filtres.familles.initialiser(this, familles)
    },
    filtrer(produit) {
      //Filtre les propositions en fonction de la barre de filtres
      return this.filtres.statuts.filtrer(this, produit) && this.filtres.designationsProduit.filtrer(this, produit)
    },

    /* ************************ GESTION DES PROPOSITIONS *************************************** */
    totalCategorie(categorie) {
      return this.totalPrixParCategorie.filter(c => c.categorieId === categorie.categorieId).shift()
    },
    totaleVariations() {
      return this.totalPrixParCategorie?.reduce((acc, obj) => {return acc + obj?.totalPropo}, 0) - this.totalPrixParCategorie?.reduce((acc, obj) => {return acc + obj?.totalActif}, 0)
    },
    afficherPourcentageVariationTotale() {
      return this.afficherPourcentageFluctuation(this.totalPrixParCategorie?.reduce((acc, obj) => {return acc + obj?.totalPropo}, 0), this.totalPrixParCategorie?.reduce((acc, obj) => {return acc + obj?.totalActif}, 0))  
    },
    pourcentageVariationTotale() {
      return this.pourcentageFluctuation(this.totalPrixParCategorie?.reduce((acc, obj) => {return acc + obj?.totalPropo}, 0), this.totalPrixParCategorie?.reduce((acc, obj) => {return acc + obj?.totalActif}, 0))
    },
    async chargerPropositionsApresImport() {
      //Recharge la liste des propositions apres l'import d'un fichier de cotation ou de fiches techniques
      let propositionId = this.filtres.dateActivation.selection?.valeur
      let familleId = this.filtres.familles.selection?.valeur

      if (propositionId && familleId && !this.propoArticleSelectionnee) {
        await this.chargerPropositions(this.fournisseurCourantId, propositionId, familleId)  
      } else {
        await this.chargerErreursDansPropositions()
        this.chargerOptionsStatuts()
      }
      console.log("Apres chargement proposition")
      this.key++
    },
    async chargerPropositions(fournisseurId, propositionId, familleId, avecSpinner=true) {
      //Récupère les propositions articles fournisseurs sur la date et la famille sélectionnée
      if (avecSpinner)
        this.$store.commit('uxHelpers/showSpinner')

      let response = await obtenirPropositions(fournisseurId, propositionId, familleId)
      this.tableauPropositions = response.data

      this.listeProduitsModifies = []
      this.chargerOptionsStatuts()
      this.donneesInitiales = _.cloneDeep(this.tableauPropositions)
      
      if (avecSpinner)
        this.$store.commit('uxHelpers/hideSpinner')
    },
    
    async enregistrerDonneesModifiees(avecSpinner=true, avecSuccess=true) {
      //Enregistre les propositions articles fournisseur
      let propositionId = this.propositionSelectionnee?.valeur
      let familleId = this.familleSelectionnee?.valeur

      //On met à jour la famille sélectionnée si besoin
      if (!familleId && this.filtres.familles && this.filtres.familles.selection) {
        familleId = this.filtres.familles.selection.valeur
        this.familleSelectionnee = this.filtres.familles.selection
      }

      if (propositionId && familleId) {
        if (avecSpinner)
          this.$store.commit('uxHelpers/showSpinner')

        let ret = await enregistrerPropositions(this.fournisseurCourantId, propositionId, familleId, this.tableauPropositions)

        if (avecSpinner)
          this.$store.commit('uxHelpers/hideSpinner')

        await this.chargerPropositions(this.fournisseurCourantId, propositionId, familleId, avecSpinner)

        if (!ret.data.familleOk) {
          await this.alerteWarning("Des erreurs sont apparues lors de l'enregistrement de vos propositions :<br/>" + ret.data.messagesErreurs)
        } else {
          if (avecSuccess)
            await this.alerteSucces(plurielUC(ret.data.nombreProposTraitees, "proposition") + " " + plurielUC(ret.data.nombreProposTraitees, " enregistrée") + " !")
          //calculerCAPropositions(this.fournisseurCourantId, propositionId, familleId) //Appel asynchrone du calcul des CA
        }
      }
    },
    async envoyerPropositions() {
      //Change le statut des propositions pour les envoyer au service Achats
      let propositionId = this.filtres.dateActivation.selection?.valeur
      let familleId = this.filtres.familles.selection?.valeur
      let objParam = {}

      if (propositionId) {
        if (familleId) {
          if (this.donneesModifiees) {
            // Envoi interdit en cas de modifications en cours
            this.alerteErreur("Des propositions sont en cours de modification. Merci d'enregistrer vos modifications avant d'envoyer vos propositions en validation par le service Achats.")
            return
          }

          if (!this.contientPropositionsModifiables(this.tableauPropositions)) {
            // Aucune proposition à envoyer
            this.alerteErreur("Aucune proposition à envoyer.")
            return
          }

          //On vérifie si les propositions sont en erreurs ou non, si oui, on n'envoi pas 
          let propoKO = this.listeProduitsAvecErreurProposition()
          if (propoKO.length > 0) {
            // Envoi interdit en cas d'erreur
            this.alerteErreur("Les propositions à envoyer contiennent des erreurs bloquantes. Merci de les corriger.")
            // pour afficher les erreurs si aucune proposition n'a été modifiée avant envoi
            this.tableauPropositions.afficherErreurs = true
            this.chargerOptionsStatuts()
            this.filtres.statuts.selection = this.filtres.statuts.options.find(x => x.valeur === 0)
            return  
          }

          objParam = {
            propositionId: propositionId,
            listeFamillesId: [familleId],
            userName: ''
          }
				
        }
        else {
          //On va envoyer toutes les familles possible
          objParam = {
            propositionId: propositionId,
            listeFamillesId: this.filtres.familles.options.filter(f => f.valeur).map(o => o.valeur),
            userName: ''
          }
        }
        
        if (familleId && !this.contientPropositionsEnregistrees(this.tableauPropositions)) {
          let response = await this.alerteConfirmation("Propositions non modifiées", "Nous n'avons détecté aucune modification dans vos propositions. Etes-vous sûr de vouloir les envoyer ?", "Oui", "Non", "warning", couleurs.erreur)
          if (!response)
            return  
          else {
            this.$store.commit('uxHelpers/showSpinner')
            await this.enregistrerDonneesModifiees(false, false)  
          }
        } else {
          let response = await this.alerteConfirmation("Envoyer les propositions", "Vos propositions vont être transmises au service Achats pour analyse. Souhaitez-vous continuer ?")
          if (!response)
            return
        }

        //On vérifie si les propositions sont en warning ou non, si oui, on affiche une alerte pour demander si on doit continuer, uniquement si on a sélectionné une famille
        if (familleId) {
          let propoWarn = this.listeProduitsAvecAvertissementProposition()
          if (propoWarn.length > 0) {
            let response = await this.alerteConfirmation("Avertissement sur propositions", "Les propositions à envoyer contiennent des avertissements qui alertent sur d'éventuelles erreurs de prix.<br/>Etes-vous sûr de vouloir les envoyer ?", "Envoyer", "Modifier les propositions", "warning", couleurs.warning)
            if (!response) {
              this.filtres.statuts.selection = this.filtres.statuts.options.find(x => x.warning)
              return  
            }
          }
        }
        
        this.$store.commit('uxHelpers/showSpinner')

        let retour = await envoyerPropositions(this.fournisseurCourantId, objParam)

        this.$store.commit('uxHelpers/hideSpinner')

        if (familleId)
          await this.chargerPropositions(this.fournisseurCourantId, propositionId, familleId)

        if (retour.data && retour.data.every(x => x.familleValide)) {
          this.listeErreurEnvoiePropositions = []
          //On n'affiche pas les warnings sur le retour d'envoie vu que le fournisseur ne peut rien en faire
          /*if (retour.data.some(x => x.afficherWarning)) {
            let listeToutesInfosWarning = retour.data.map(x => x.listeWarningInfos).join("<br/><br/>")
            this.alerteWarning("Des propositions sont envoyées avec des avertissements :<br/><br/>" + listeToutesInfosWarning, couleurs.warning)
          } else {*/
          let listeToutesInfos = retour.data.map(x => x.listeToutesInfos).join("<br/><br/>")
          let listeTousWarnings = retour.data.map(x => x.listeTousWarnings).filter(x => x != "").join("<br/><br/>")
          this.alerteWarning(listeTousWarnings + "<br/><br/>" + listeToutesInfos, "Propositions envoyées", "success", couleurs.sucess)
          if (familleId)
            this.chargerOptionsStatuts()
          this.key++
        } else {
          if (retour.data) {
            this.listeErreurEnvoiePropositions = retour.data
            let listeToutesInfos = retour.data.map(x => x.listeToutesInfos).filter(x => x != "").join("<br/><br/>")
            let listeToutesErreurs = retour.data.map(x => x.listeToutesErreurs).filter(x => x != "").join("<br/><br/>")

            listeToutesInfos = listeToutesInfos.replace(/; /g, "<br/>")
            listeToutesErreurs = listeToutesErreurs.replace(/; /g, "<br/>")

            console.log("Retour Erreurs")
            console.log(listeToutesErreurs)

            this.alerteWarning("Des erreurs sont apparues lors de l'envoi de vos propositions :<br/><br/>" + listeToutesErreurs + "<br/><br/>" + listeToutesInfos, "Attention", "warning", couleurs.erreur)
                              .then(async (r) => {
                                //On se positionne sur la premiere famille en erreur, et on filtre sur la premiere erreur, apres avoir cliqué sur le bouton OK du message
                                let famIdErr = retour.data.filter(x => !x.familleValide).first().familleId
                                if (famIdErr) {
                                  this.filtres.familles.selection = this.filtres.familles.options.filter(f => f.valeur === famIdErr).first()
                                  await this.chargerPropositions(this.fournisseurCourantId, propositionId, famIdErr)
                                  this.chargerOptionsStatuts()
                                  this.filtres.statuts.selection = this.filtres.statuts.options.find(x => x.valeur === 0)
                                }
                                return r
                              })
                              .catch((ex) => {return ex})
          } else {
            this.alerteWarning("Une erreur semble s'être produite lors de l'envoi de vos propositions<br/>Merci de réessayer ultérieurement.", "Attention", "error", couleurs.erreur)
          }
        }
      }
    },
    async viderProposition(proposition) {
      //vide la proposition article
      let response = await this.alerteConfirmation("Vider la proposition", "La proposition va être réinitialisée. Souhaitez-vous continuer ?")
      if (!response)
        return

      proposition.retourAgap = '' // On vide le message de retour .... il reviendra à l'enregistrement s'il y a d'autres erreurs
      proposition.lienFicheTechnique = ""
      
      this.alimenterProposition(proposition?.propositionEnCours, null)
    },
    alimenterProposition(proposition, donnees) {
      //permet d'alimeneter les données de la proposition, soit pour la vider, ou pour récupérer le tarif actif
      if (!proposition)
        return

      // Le prix est vidé systématiquement, il n'est jamais repris des données à copier
      proposition.prixUnitaireHT = null

      // Le reste des données est copié normalement, ou vidé si aucune donnée à copier n'est fournie
      proposition.designation = donnees?.designation ?? null
      proposition.reference = donnees?.reference ?? null
      proposition.marque = donnees?.marque ?? null
      proposition.pcb = donnees?.pcb ?? null
      proposition.uniteFacturation = donnees?.uniteFacturation ?? null
      proposition.uniteCommandeEDI = donnees?.uniteCommandeEDI ?? null
      //proposition.lienFicheTechnique = donnees?.lienFicheTechnique ?? null
      proposition.cheminAzureFicheTechnique = donnees?.cheminAzureFicheTechnique ?? null
      proposition.codeEANArticle = donnees?.codeEANArticle ?? null
      proposition.codeEANCarton = donnees?.codeEANCarton ?? null
      proposition.commentaireFournisseur = donnees?.commentaireFournisseur ?? null
    },
    propositionEstVide(proposition) {
      if (!proposition)
        return true
      
      return !proposition.designation &&
             !proposition.reference &&
             !proposition.marque &&
             !proposition.pcb &&
             !proposition.prixUnitaireHT &&
             !proposition.uniteFacturation &&
             !proposition.uniteCommandeEDI //&&
            //  !proposition.lienFicheTechnique &&
            //  !proposition.codeEANArticle &&
            //  !proposition.codeEANCarton
    },
    propositionEstComplete(proposition) {
      if (!proposition)
        return true

      if (proposition.id)
        return proposition.estConforme && (proposition.retourAgap === "" || proposition.enLectureSeule)
      else
        return proposition.designation && 
               proposition.pcb && 
               proposition.prixUnitaireHT && 
               proposition.uniteFacturation && 
               proposition.ficheTechniqueAzureOk
    },
    propositionEstWarning(propoFournisseur) {
      if (!propoFournisseur)
        return false

      if (propoFournisseur.propositionEnCours?.enLectureSeule ?? false)
        return false

      return propoFournisseur.warningConformite && 
             propoFournisseur.warningConformite.length > 0
    },
    listeWarningSuiteEnvoie(propoFournisseur) {
      return this.listeWarningEnvoieFamilleSelectionnee.filter(x => x.propositionArticleFournisseurId === propoFournisseur.id && this.controleErreurEnvoie(propoFournisseur, x)).map(x => x.erreur)?.join(" - ") || ""
    },
    listeErreurSuiteEnvoie(propoFournisseur) {
      return this.listeErreurEnvoieFamilleSelectionnee.filter(x => x.propositionArticleFournisseurId === propoFournisseur.id && this.controleErreurEnvoie(propoFournisseur, x)).map(x => x.erreur)?.join(" - ") || ""
    },
    controleErreurEnvoie(propositionFournisseur, erreurEnvoie) {
      //Permet de dire si l'erreur ou le warning retourné lors de l'envoie des propositions est toujours valable suite à des modifications des valeurs (référence et/ou désignation et/ou FT)
      //retourne vrai pour dire que l'erreur est toujours d'actualité, sinon faux
      //Si la référence ou la désignation ou la FT de la proposition est différente des données de l'erreur, on peut considérer que l'erreur est corrigée
      if (erreurEnvoie.reference !== "" && propositionFournisseur.reference != erreurEnvoie.reference && erreurEnvoie.checkSumMD5FT === "") 
        return false

      if (erreurEnvoie.designation !== "" && propositionFournisseur.designation != erreurEnvoie.designation && erreurEnvoie.checkSumMD5FT === "")
        return false

      if (erreurEnvoie.checkSumMD5FT !== "" && propositionFournisseur.checkSumMD5FicheTechnique !== erreurEnvoie.checkSumMD5FT)
        return false
      
      if (erreurEnvoie.propositionArticleFournisseurDoublonId) {
      // Contrôle du doublon
        let propoDoublon = this.listeProduits(this.tableauPropositions).map(p => p.propositionsFournisseurs).reduce((a,b) => a.concat(b), []).map(pf => pf.propositionEnCours).reduce((a, b) => a.concat(b), []).find(pec => pec.id === erreurEnvoie.propositionArticleFournisseurDoublonId)
        let erreurDoublon = this.listeErreurEnvoieFamilleSelectionnee.filter(x => x.propositionArticleFournisseurId === propoDoublon.id)[0]

        if (erreurDoublon.reference !== "" && propoDoublon.reference != erreurDoublon.reference && erreurEnvoie.checkSumMD5FT === "") 
          return false

        if (erreurDoublon.designation !== "" && propoDoublon.designation != erreurDoublon.designation && erreurEnvoie.checkSumMD5FT === "")
          return false
      }

      return true
    },
    propositionEstConforme(proposition) {
      return this.propositionEstComplete(proposition) || this.propositionEstVide(proposition)
    },
    afficherPCBetUC(pcb, uc) {
      let arrondi = arrondiMercuriale(pcb)
      if (!arrondi)
        return ""
      return arrondi + " " + uc
    },
    afficherPrixPcbUc(prix, pcb, uc) {
      if (!Nombre(prix) || !Nombre(pcb))
        return ""

      return arrondiPrixPCB(pcb, pcb, prix) + " / " + pcb + " " + uc
    },
    afficherPrixConverti(prix, pcb, uc, unite) {
      if (!Nombre(prix) || !Nombre(pcb))
        return ""
      return arrondiPrixPCB(pcb, pcb, prix) + " / " + (unite && unite != uc ? (unite) : (pcb + " " + uc))
    },
    pourcentageFluctuation(prix1, prix2) {
      return arrondiPourcentageDifference(prix1, prix2)
    },
    afficherPourcentageFluctuation(prix1, prix2) {
      let prc = arrondiPourcentageDifference(prix1, prix2)
      if (prc > 0)
        return "+" + prc + "%"
      return prc + "%"
    },
    estVisible(produit) {
      let propositionFournisseur = this.propositionFournisseur(produit)
      if (!propositionFournisseur)
        return false

      // Toute proposition en cours de modification est masquée lorsque la date d'activation des propositions est dépassée
      if (this.formatDateAvecTirets(new Date()) >= this.formatDateAvecTirets(this.filtres.dateActivation.selection) && !(propositionFournisseur.propositionEnCours?.enLectureSeule ?? true))
        return false

      return true
    },
    estModifiableParAgap(proposition) {
      if (!proposition)
        return false
      return proposition.enLectureSeule
    },
    toutesPropositionsModifiablesParAgap(tableauPropositions) {
      return !this.listeProduits(tableauPropositions).some(p => !this.estModifiableParAgap(this.propositionFournisseur(p)?.propositionEnCours))
    },
    contientPropositionsModifiables(tableauPropositions) {
      return this.listeProduits(tableauPropositions).some(p => this.estModifiable(this.propositionFournisseur(p)?.propositionEnCours))
    },
    contientPropositionsEnregistrees(tableauPropositions) {
      //Permet de savoir si la vue affichée sur l'écran correspond à des propositions enregistrée en base de données (toutes les propos)
      return this.listeProduits(tableauPropositions).every(p => this.estEnregistree(this.propositionFournisseur(p)?.propositionEnCours))
    },
    periodeFamilleEstModifiable() {
      return this.filtres.dateActivation.selection?.ouvertePourSaisie && this.filtres.familles.selection?.ouvertePourSaisie
    },
    estModifiable(proposition) {
      if (!proposition)
        return false
      if (!this.periodeFamilleEstModifiable())
        return false
      return !proposition.enLectureSeule
    },
    estEnregistree(proposition) {
      if (!proposition)
        return false

      return proposition.id ? true : false
    },
    estModifie(produit) {
      if (!produit)
        return false
      return this.listeProduitsModifies.some(p => p.produitAgapId === produit.produitAgapId)
    },
    valeurEstModifiee(nomChamp, produit) {
      if (!produit)
        return false

      let valOld
      //Si la derniereProposition n'existe pas, on compare avec le Tarif actif si existant
      if (!this.propositionFournisseur(produit)?.derniereProposition) {
        if (this.propositionFournisseur(produit)?.prixActif) {
          valOld = this.propositionFournisseur(produit)?.prixActif[nomChamp] ?? ""
        } else
          return false
      } else
        valOld = this.propositionFournisseur(produit)?.derniereProposition[nomChamp] ?? ""
        
      
      //console.log("Valeur Modifiee ? : [" + nomChamp + "] : (" + (this.propositionFournisseur(produit)?.propositionEnCours[nomChamp] ?? '') + ") =?= (" + (this.propositionFournisseur(produit)?.derniereProposition[nomChamp] ?? '') + ")")
      //
      return (this.propositionFournisseur(produit)?.propositionEnCours[nomChamp] ?? "") !== valOld
    },
    recupereChampsAComparer(produit, champs) {
      return Object.fromEntries(champs.map(c => [c, produit[c] ?? ""]))
    },
    contientValeurModifiee(produit) {
      //indique si la proposition du produit a été changé depuis la derniere proposition
      if (!produit)
        return false

      let valOld
      //Si la derniereProposition n'existe pas, on compare avec le Tarif actif si existant
      if (!this.propositionFournisseur(produit)?.derniereProposition) {
        if (this.propositionFournisseur(produit)?.prixActif) {
          valOld = this.propositionFournisseur(produit)?.prixActif
        } else
          return false 
      } else
        valOld = this.propositionFournisseur(produit)?.derniereProposition

      let listeChamps = ["designation", "marque", "reference", "prixUnitaireHT", "pcb", "uniteFacturation", "uniteCommandeEDI", "commentaireFournisseur"] // "checkSumMD5FicheTechnique"] //On ne controle pas la FT pour le moment, car on ne peut pas afficher un bouton en gras, à voir plus tard comment la prendre en compte ...
      //De plus sur les propositions, il n'y a pas de FT par défaut, donc il faut comparer avec la FT du prix actif .... chose impossible tel que c'est fait là .... 

      return !_.isEqual(JSON.stringify(this.recupereChampsAComparer(this.propositionFournisseur(produit)?.propositionEnCours, listeChamps)), JSON.stringify(this.recupereChampsAComparer(valOld, listeChamps)))
    },
    contientValeurNonModifiee(produit) {
      //indique si la proposition du produit n'a pas été changé depuis la derniere proposition
      return !this.contientValeurModifiee(produit)
    },
    contientModification(produit) {
      if (!produit)
        return false
      let produitInitial = this.listeProduits(this.donneesInitiales).find(p => p.produitAgapId === produit.produitAgapId)
      if (!produitInitial)
        return true
      return !_.isEqual(JSON.stringify(produitInitial), JSON.stringify(produit))
    },

    majlisteProduitsModifies() {
      let produit = this.listeProduits(this.tableauPropositions).find(p => p.produitAgapId === this.produitSelectionneId)
      if (produit) {
        let produitModifie = this.contientModification(produit)
        let produitDansListeModif = this.estModifie(produit)
        if (produitModifie && !produitDansListeModif) {
          this.listeProduitsModifies.push(produit)
        } else if (!produitModifie && produitDansListeModif) {
          this.listeProduitsModifies = this.listeProduitsModifies.filter(p => p.produitAgapId !== produit.produitAgapId)
        }
      }
    },
    listeProduits(tableauPropositions) {
      return tableauPropositions?.categories?.map(c => c.sousCategories).reduce((a, b) => a.concat(b), []).map(sc => sc.produits).reduce((a, b) => a.concat(b), []) || []
    },
    listeProduitsAvecErreurProposition() {
      return this.listeProduits(this.tableauPropositions).filter(x => this.propositionFournisseur(x).erreursConformite && this.propositionFournisseur(x).erreursConformite.length > 0)
    },
    listeProduitsAvecAvertissementProposition() {
      return this.listeProduits(this.tableauPropositions).filter(x => this.propositionFournisseur(x).warningAgap && this.propositionFournisseur(x).warningAgap !== "" && !this.propositionFournisseur(x).propositionEnCours.enLectureSeule)
    },
    propositionFournisseur(produit) {
      return produit?.propositionsFournisseurs?.find(pf => pf.fournisseurId === this.fournisseurCourantId)
    },
    nbLignesAffichageProposition(produit) {
      let nbLignes = 0  // Ligne de proposition en cours
      if (this.estVisible(produit)) {
        nbLignes += this.propositionFournisseur(produit)?.retourAgap ? 2 : 1
      }
      if (this.filtres.afficherHistoriquePropositions.selection) {
        this.propositionFournisseur(produit)?.historiquePropositions?.forEach(p => {
          nbLignes += p.retourAgap ? 2 : 1
        })
      }
      return nbLignes
    },
    couleurHexCss(couleur, pourcentageOpacite) {
      if (!couleur)
        return ""
      return (couleur.charAt(0) != "#" ? "#" : "") + couleur + (convertirPourcentageToHex(pourcentageOpacite) ?? "")
    },
    champObligatoire(produit, valeur, obligatoire) {
      //On indique si le champ est obligatoire uniquement si la ligne est sélectionnée
      if (produit.produitAgapId === this.produitSelectionneId && obligatoire && !valeur && !this.propositionEstVide(this.propositionFournisseur(produit)?.propositionEnCours)) {
        return "fas fa-exclamation text-danger ml-1"
      } else {
        return "";
      }
    },
    styleBordure(bordureCss, produit, nbPxEpaisseur, pourcentageOpacite) {
      let propositionFournisseur = this.propositionFournisseur(produit)
      if (!propositionFournisseur?.propositionEnCours?.couleur || !Nombre(nbPxEpaisseur))
        return ""
      let style = bordureCss ? bordureCss + ":" : ""
      return style + "solid " + nbPxEpaisseur + "px " + this.couleurHexCss(propositionFournisseur.propositionEnCours.couleur, pourcentageOpacite)
    },

    /* ******************************* GESTION DU CURSEUR POUR NAVIGATION TABLEAU ************************** */
    positionProduit(produits, produitId) {
      return produits.map(p => p.produitAgapId).indexOf(produitId)
    },
    selectionnerProduit(produitId) {
      this.majlisteProduitsModifies()
      this.produitSelectionneId = produitId
    },
    deplacerCurseurTexte(produitId, col, e) {
      this.deplacerCurseur(produitId, col, deplacerCurseur(e, true))
    },
    deplacerCurseur(produitId, col, e) {
      let sensLigne = 0
      let sensColonne = 0
      if (e?.direction === "up") {
        sensLigne = -1
      } else if (e?.direction === "down") {
        sensLigne = 1
      } else if (e?.direction === "left") {
        sensColonne = -1
      } else if (e?.direction === "right") {
        sensColonne = 1
      }
      if (sensLigne !== 0) {
        let produits = this.listeProduits(this.tableauPropositions).filter(p => this.filtrer(p) && this.estModifiable(this.propositionFournisseur(p)?.propositionEnCours))
        let indice = this.positionProduit(produits, produitId)
        if (indice < 0)
          return
        indice = calculerIndiceDeplacement(indice, sensLigne, produits.length)
        if (indice == null)
          return
        produitId = produits[indice]?.produitAgapId
        if (!produitId)
          return
      }
      if (sensColonne !== 0) {
        col = calculerIndiceDeplacement(col, sensColonne, 8)
      }
      // Recherche et sélection du champ suivant selon la flèche du clavier
      let champ = document.getElementById("col" + (col) + produitId)
      if (champ) {
        this.selectionnerProduit(produitId)
        champ.focus()
      }
    }
    
  }
}
</script>
